<div cdkDropList [cdkDropListData]="actionsByPerson" (cdkDropListDropped)="drop($event)">
    <ng-container
        *ngFor="let groupedActor of actionsByPerson; int let i = index; let firstitem = first; let lastitem = last;">
        <li class="list-group-item d-block pt-0 pe-0 pb-0 ps-2 subtable grouped" [ngClass]="{'pb-2': lastitem, 'no-header-bottom-border': !lastitem, 'lastItem': lastItemOfPersonsInSendgroup }" cdkDrag cdkDragLockAxis="y" [cdkDragDisabled]="!sortingAllowed">
            <desktop-builder-sendgroup-action-table-row [actorInSendgroup]="groupedActor" [documents]="documents" [showMenu]="false"
                [sortingAllowed]="true" [index]="i"></desktop-builder-sendgroup-action-table-row>
        </li>
    </ng-container>
</div>